/**
 * Adapters between ScheduleEntryForm's Daily Schedule v2 body shape
 * and the transcript's captured-item payload shape (matches what the
 * Python agent emits and what Go's SaveSection fan-out reads on Save &
 * next).
 *
 *   ScheduleEntryForm onSave body   → captured "add" payload
 *   {timeMinutes, activity}
 *      →
 *   {timeMinutes, time_minutes, activity, value}
 *
 * Both key spellings (camelCase + snake_case) are round-tripped for
 * symmetry — the Go adapter accepts either.
 */

const clockLabel = (m) => {
  const total = Number(m);
  if (!isFinite(total)) return "";
  const h24 = Math.floor(total / 60);
  const mm = total % 60;
  const ampm = h24 < 12 ? "am" : "pm";
  let h12 = h24 % 12;
  if (h12 === 0) h12 = 12;
  return `${String(h12).padStart(2, "0")}:${String(mm).padStart(2, "0")} ${ampm}`;
};

/**
 * ScheduleEntryForm onSave body → captured "add" payload.
 */
export function bodyToCapturedAdd(body) {
  const tm = Number(body.timeMinutes) || 0;
  const activity = (body.activity || "").trim();
  return {
    timeMinutes:  tm,
    time_minutes: tm,
    activity,
    // Convenience for the review table's display column — "07:00 am · Wake up".
    value: activity ? `${clockLabel(tm)} · ${activity}` : clockLabel(tm),
  };
}

/**
 * Stub — Wave C first-cut doesn't route Daily Schedule updates via AI.
 * Symmetric with the other section adapters.
 */
export function bodyToCapturedUpdate(body /* , context */) {
  return bodyToCapturedAdd(body);
}
